import {Component, effect, EventEmitter, Input, Output, signal} from '@angular/core';
import {FigmaImageComponent} from "../figma-image/figma-image.component";
import {BuilderV2Service} from "../../../../../../builder-v2.service";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {FigmaScreenshotI} from "../../../../../../builder-v2.interface";

@Component({
    selector: 'db-figma-link',
    imports: [
        FigmaImageComponent
    ],
    templateUrl: './figma-link.component.html',
    styleUrl: './figma-link.component.scss'
})
export class FigmaLinkComponent {
    figmaResp = signal<FigmaScreenshotI>(
        null
    );
// {
//   "file_key": "IXUXaZmFV7azlhJx3fmGHU",
//   "node_id": "7777-98562",
//   "node_name": "HELLO",
//   "screenshot_url": "https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/0d7c9a81-2a6f-4405-bf4d-018bd80bf569"
// }
    inputValue = signal('');
    isLoading = signal(false);
    @Output() closeFigma = new EventEmitter<void>();
    @Output() figmaRespTrigger = new EventEmitter<any>();

    constructor(private _builderV2Service: BuilderV2Service, private _builderInteractionService: BuilderSectionsInteractionService) {
      effect(() => {
        this._builderInteractionService.vibeCodingLoading.next(this.isLoading());
      });
    }

    onChangeValue(event: Event): void {
        const ev = event.target as HTMLInputElement;
        this.inputValue.set(ev.value)
    }

    onKeyDown(e: KeyboardEvent) {
        if ((e.key === 'Backspace' || e.key === 'Delete') && !this.inputValue()) {
            this.closeFigma.emit();
        }
    }

    onPaste($event: any) {
        this.inputValue.set($event.clipboardData.getData('text'))
        this._getFigmaScreenshot();
        $event.currentTarget?.blur();
    }

    clearValue() {
        if (this.inputValue().trim() === '') {
            this.onCloseFigma();
        }
        this.inputValue.set('');
    }

    onCloseFigma(): void {
        this.closeFigma.emit();
        this._builderInteractionService.vibeCodingFigma = null;
    }

    private _getFigmaScreenshot() {
        if (!this.inputValue().trim().length) {
            return;
        }
        this.isLoading.set(true);
        this._builderV2Service.getFigmaScreenshot(this.inputValue())
            .subscribe(resp => {
                if (resp) {
                    this.isLoading.set(false);

                    if (resp.success) {
                        this.figmaResp.set(resp.data)
                        this.figmaRespTrigger.emit(resp.data)
                        this._builderInteractionService.vibeCodingFigma = resp.data

                    } else {
                        NotifierComponent.notify(new Notification(resp.message, NotificationType.DANGER, true));
                        this.inputValue.set('');
                        this._builderInteractionService.vibeCodingFigma = null;
                    }
                }
            })
    }
}
